<template>
  <div class="car-list-navbar" :class="{ 'slide-down': showCarListNav }">
    <div class="logo">
      <img src="/assets/~/media/images/activity/policy2602/pc/slogan.jpg" alt=""/>
    </div>
    <ul>
      <li v-for="(item, index) in carNavbarList" :key="index"
          :class="{ 'li-active': activeItem === index }"
          :style="{ 'width': [2, 3].includes(index)  ? 'calc(200 / 2200 * 100vw)' : '' }"
          @click="scrollTo(item,index)"
          :code-stm="`event, PAGEURL, 车型导航点击_${item.name }`" >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      clickItem:'',
      clickItemIndex:null,//点击li对应的index
      scrollRangeId:null,//滚动中当前的页面id
      activeItem: '',//active对应的index
      carNavbarList: [
        {id: 'page1',name:'EV5',text:'ev5',index:0},
        {id: 'page2',name:'EV6',text:'ev6',index:1},
        {id: 'page3',name:'狮铂拓界',text:'sportage',index:2},
        {id: 'page4',name:'2026款 赛图斯',text:'seltos',index:3},

        {id: 'part1',name:'智跑',text:'zhipao',index:4},
        {id: 'part1',name:'2026款 奕跑',text:'carnival',index:5},

        {id: 'part2',name:'索奈',text:'sonet',index:6},
        {id: 'part2',name:'2026款 嘉华',text:'kx1',index:7},

        {id: 'part3',name:'K3',text:'k3',index:8},
        {id: 'part3',name:'K5',text:'k5',index:9},
      ],
      idList:['page1','page2','page3','page4','part1','part2','part3',],

      lastScrollTop : 0,

      winScroll:0,
      scrollingTimer: null,
      showCarListNav:false,
    }
  },
  mounted() {
    // this.calculateSectionPositions();
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.winScroll = window.scrollY;
      if(!this.isPortrait){
        this.updateActiveItem();
      }
      //滚动定时器
      if (this.scrollingTimer) {
        clearTimeout(this.scrollingTimer);
      }
      this.scrollingTimer = setTimeout(() => {
        // 用户停止滚动后的操作
        // console.log('用户停止滚动了');
        this.clickItemIndex = null;//清除clickItemIndex
      }, 200);
    },
    updateActiveItem() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // console.log(scrollTop);
      //滑至ev5显示导航栏
      if (scrollTop > window.innerHeight / 4) {
        this.showCarListNav = true;
      } else {
        this.showCarListNav = false;
      }

      for (let i = 0; i < this.idList.length; i++) {
        const id = this.idList[i];
        const vh = window.innerHeight;
        const gapVal = vh / 2
        const element = document.getElementById(id);
        if (element) {
          const offset = element.getBoundingClientRect().top + window.scrollY;
          const height = element.offsetHeight;
          if (this.winScroll >= (offset - gapVal) && this.winScroll < (offset + height - gapVal)) {
            this.scrollRangeId = id;
            //在carNavbarList中找到对应的车型
            var filterList = this.carNavbarList.filter(item => item.id === id);
            if(filterList.length == 1){//单车页面
              if(this.clickItemIndex !== null){//如果是 点击 导致的滚动
                //除了点击的item，其他item的active都不要
                if(this.clickItemIndex !== i){
                  // console.log('别换index了');
                }else{
                  this.activeItem = this.clickItemIndex
                  // console.log('换成点击的index了')
                }
              }else{
                this.activeItem = filterList[0].index;
              }
            }else if(filterList.length > 1){//多车页面
              if(this.clickItemIndex !== null){//如果是 点击 导致的滚动
                //找到点击储存的index
                this.activeItem = this.clickItemIndex
              }else{
                // console.log('没有找到点击储存的index')
                //判断一下当前active的index 与 将要变成的index
                //1.id是否相同
                //2.当前的index是否在 将要变成index的后面 (当前index > 将要变成index)
                //3.是否向下滚动
                //如果满足1.2.3，则 不改变this.activeItem
                var oldId = this.carNavbarList.find(item => item.index == this.activeItem)?.id;
                var newId = this.carNavbarList.find(item => item.index == filterList[0].index)?.id;
                var isDown
                if (scrollTop > this.lastScrollTop) {
                  // console.log('用户正在向下滚动');
                  isDown= true
                } else {
                  // console.log('用户正在向上滚动');
                  isDown= false
                }
                if(oldId == newId && this.activeItem > filterList[0].index && isDown){//如果满足1.2.3
                  // console.log('别换index了');
                }else{
                  this.activeItem = filterList[0].index;//显示第一个
                }
              }
            }
            break;
          }
        }
      }
      this.lastScrollTop = scrollTop;
    },
    scrollTo(item, index) {
      const element = document.getElementById(item.id);
      if (element) {
        const yOffset = -78;//头的高度留出来
        // const yOffset = 0;//不留头了
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.scrollY + yOffset,
          behavior: 'smooth'
        });
        this.activeItem = index;
        this.clickItemIndex = item.index
      }
    },

  }
}
</script>

<style scoped>
@media (min-width: 767px) {
  .car-list-navbar {
    height: 78px;
    width: 100%;
    position: fixed;
    /* top: 0; */
    top: -100%;
    background-color: #ffffff;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    transition: top 0.5s;
  }
  .slide-down {
    top: 0;
  }
  .car-list-navbar ul {
    margin-right: calc(90 / 2200 * 100vw);;
  }
  .car-list-navbar .logo {
    height:100%;
    /* margin-left: calc(78 / 2200 * 100vw); */
    display: flex;
    align-items: center;
    justify-content: end;
  }
  .car-list-navbar .logo img {
    /* width: calc(193 / 2200 * 100vw);
    height: calc(71 / 2200 * 100vw); */
    width:410.56px;
    height: 78px;
  }

  .car-list-navbar ul {
    display: flex;
    list-style: none;
    padding: 0;
    height: 78px;
    align-items: center;
    justify-content: end;
  }

  .car-list-navbar li {
    cursor: pointer;
    color: #606060 ;
    /* margin: 0 calc(24 / 2200 * 100vw); */
    font-size: calc(18 / 2200 * 100vw);
    width: calc(110 / 2200 * 100vw);
    /* height: 100%; */
    height: 78px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-bottom: solid 2px #ffffff;
  }

  li:hover {
    border-bottom: solid 2px #242424;
    color: #000000;
  }
  .li-active {
    border-bottom: solid 2px #242424 !important;
    color: #000000 !important;
  }
}

</style>
